import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class TermsOfUseModal extends Vue {
  cleanDescription = this.$sanitize(this.$t("components.popinTermsOfUse.description").toString());
  validationCheck = 'not_accepted';
  closeModal(): void {
    this.$emit("close");
  }
}
